<template>
    <div class="FM_withdrawalList">
        <!-- 用户搜索 -->
        <el-card class="box-card" shadow="hover" v-if="level == 0">
            <el-form :inline="true" :model="withdrawalForm" class="demo-form-inline">
                <el-form-item>
                    <el-input size clearable v-model="withdrawalForm.tel" placeholder="请输入投诉商户账号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button
                            size="medium"
                            type="primary"
                            icon="el-icon-search"
                            style="font-size: 12px;"
                            @click="handleSearch(withdrawalForm)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 用户列表 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover" v-if="level == 0">
            <el-table
                    :data="wTable"
                    size="mini"
                    border
                    style="width: 100%"
                    v-loading="loading"
            >
                <el-table-column
                        header-align="center"
                        align="center"
                        fixed
                        type="index"
                        label="ID"
                        min-width="80"
                ></el-table-column>
                <!-- 所属机构 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="agent_name"
                        label="所属机构"
                        min-width="120"
                ></el-table-column>
                <!-- 所属机构 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="agent_tel"
                        label="所属机构手机号"
                        min-width="120"
                ></el-table-column>
                <!-- 商户姓名 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="name"
                        label="商户名称"
                        min-width="120"
                ></el-table-column>
                <!-- 商户姓名 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="corporate_name"
                        label="商户姓名"
                        min-width="120"
                ></el-table-column>
                <!-- 商户手机号 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="tel"
                        label="商户手机号"
                        min-width="120"
                >
                </el-table-column>
                <!-- 操作 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        fixed="right"
                        label="操作"
                        min-width="150"
                >
                    <template slot-scope="scope">
                        <el-button
                                type="text"
                                size="small"
                                slot="reference"
                                @click="handleUndo(scope.row)"
                        >添加处罚</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <!-- 投诉搜索 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="litigationForm" class="demo-form-inline">
                <el-form-item>
                    <el-input size clearable v-model="litigationForm.tel" placeholder="投诉人账户"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button
                            size="medium"
                            type="primary"
                            icon="el-icon-search"
                            style="font-size: 12px;"
                            @click="Search(litigationForm)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 投诉列表 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table
                    :data="withdrawalTable"
                    size="mini"
                    border
                    style="width: 100%"
                    v-loading="loading"
            >
                <el-table-column
                        header-align="center"
                        align="center"
                        fixed
                        type="index"
                        label="ID"
                        min-width="80"
                ></el-table-column>
                <!-- 投诉人 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="merchant_detail"
                        label="投诉人"
                        min-width="120"
                ></el-table-column>
                <!-- 被投诉人 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="user_detail"
                        label="被投诉人"
                        min-width="120"
                ></el-table-column>
                <!-- 投诉金额 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="money"
                        label="投诉金额(元)"
                        min-width="80"
                ></el-table-column>
                <!-- 投诉次数 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="number_of_times"
                        label="投诉次数"
                        min-width="60"
                ></el-table-column>
                <!-- 投诉次数 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="status"
                        label="状态"
                        min-width="60"
                ></el-table-column>
                <!-- 投诉时间 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="create_time"
                        label="投诉时间"
                        min-width="120"
                ></el-table-column>
                <!-- 备注说明 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        fixed="right"
                        label="详情"
                        min-width="80"
                >
                    <template slot-scope="scope">
                        <el-button
                                v-show="true"
                                @click="detailsShow(scope.row)"
                                type="text"
                                size="small"
                                v-if="scope.row.first"
                        >详情</el-button>
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        fixed="right"
                        label="操作"
                        min-width="150"
                        v-if="level==0"
                >
                    <template slot-scope="scope">
                        <el-button
                                v-show="true"
                                @click="handleUndo(scope.row)"
                                type="text"
                                size="small"
                        >再次投诉</el-button>
<!--                        <el-button-->
<!--                                v-show="true"-->
<!--                                @click="handleUp(scope.row.i_id)"-->
<!--                                type="text"-->
<!--                                size="small"-->
<!--                        >完成</el-button>-->
                        <el-button
                                v-show="true"
                                @click="feebackUp(scope.row)"
                                type="text"
                                size="small"
                                v-if="scope.row.litigation_id == scope.row.user_litigation_examine_id && scope.row.user_litigation_examine_number == scope.row.num"
                        >审核</el-button>
                        <el-button
                                v-show="true"
                                @click="deduction(scope.row)"
                                type="text"
                                size="small"
                                v-if="scope.row.num == 2"
                        >扣款</el-button>
                    </template>
                </el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        fixed="right"
                        label="操作"
                        min-width="150"
                        v-if="level!=0"
                >
                    <template slot-scope="scope">
                        <el-button
                                v-show="true"
                                @click="examineUp(scope.row)"
                                type="text"
                                size="small"
                                v-if="scope.row.deduction_user_id == admin_id"
                        >提交审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    @size-change="getPageSize"
                    @current-change="getCurrent"
                    :page-sizes="[10,20,50,100]"
                    :current-page="page.currentPage"
                    :page-size="page.pageSize"
                    :total="page.total"
                    layout="total, sizes, prev, pager, next, jumper"
                    style="text-align: center"
            ></el-pagination>
        </el-card>
        <!-- 审核&详情 -->
        <info-audit
                v-if="infoIsShow"
                :infoIsShow="infoIsShow"
                :dialogData="dialogData"
                @infoClose="infoClose"
        ></info-audit>
        <!-- 查看第一/第二次投诉 -->
        <ded-Info
                v-if="detailIsShow"
                :detailIsShow="detailIsShow"
                :dialogData="dialogData"
                @infoClose="infoClose"
                :type = "type"
        >
        </ded-Info>
        <!-- 提交审核页面 -->
        <merchant-Examine
                v-if="examineShow"
                :examineShow="examineShow"
                :dialogData="dialogData"
                @infoClose="infoClose">
        </merchant-Examine>
        <!--回馈-->
        <merchant-Feedback
                v-if="FeedbackShow"
                :FeedbackShow="FeedbackShow"
                :dialogData="dialogData"
                @infoClose="infoClose">
        </merchant-Feedback>
        <!--审核-->
        <info-audits
                v-if="infoIsShows"
                :infoIsShows="infoIsShows"
                :dialogData="dialogData"
                @infoClose="infoClose"
        ></info-audits>
    </div>
</template>

<script>
import infoAudit from './merchantDeductionAdd';
import dedInfo from './merchantDeductionInfo';
import merchantExamine from "./merchantExamine";
import merchantFeedback from "./merchantFeedback";
import infoAudits from './FM_dealpunishino';
export default {
    name: "FM_dealpunish",
    data() {
        return {
            withdrawalTable: [], //表格
            wTable: [], //表格
            infoIsShow: false, //审核弹窗
            detailIsShow: false, //查看详情弹窗
            examineShow: false, //提交审核弹窗
            FeedbackShow: false,//回馈
            infoIsShows: false, //审核弹窗
            dialogData: {
                data: {} //当前行的数据
            },
            type:1,
            withdrawalForm: {
                tel: '', //代理账号
                page:'1',
                limit:'10'
            },
            litigationForm: {
                tel: '', //代理账号
                page:'',
                limit:''
            },
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 0  //总数
            },
            loading: true,
            downLoading: false, //loading
            level: sessionStorage.getItem('level'),
            admin_id:sessionStorage.getItem('admin_id'),
        }
    },
    mounted() {
        this.getData( //初始化
            {
                page: 1,
                limit: 10,
            }
        );
    },
    components: {
        infoAudit,
        dedInfo,
        merchantExamine,
        merchantFeedback,
        infoAudits,
    },
    methods: {
        handleSearch(withdrawalForm) {
            // 表单提交
            this.getuserData(withdrawalForm);
        },
        Search(litigationForm){
           // 表单提交
            this.getData(litigationForm);
        },
        handleUndo(row) { //添加处罚
            this.infoIsShow = true;
            this.dialogData.data = row;
        },
        feebackUp(row){
            this.FeedbackShow = true;
            this.dialogData.data = row;
        },
        deduction(row){
            this.infoIsShows = true;
            this.dialogData.data = row;
        },
        detailsShow(row) { //查看处罚详情
            this.detailIsShow = true;
            this.dialogData.data = row;
        },
        examineUp(row){ //提交审核
            this.examineShow = true;
            this.dialogData.data = row;
        },
        getData(params) { //获取列表
            this.loading = true;
            this.$api.post("merchant/deduction", params, res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.page.total = data.count; //总数
                    this.withdrawalTable = data.list;
                } else {
                    this.$message.error(res.msg);
                }
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        infoClose(ref) {
            this.infoIsShow = false;
            this.detailIsShow = false;
            this.examineShow = false;
            this.FeedbackShow = false;
            this.infoIsShows = false;
            if (ref) {
                this.getData(this.litigationForm);//刷新
            }
        },
        // handleUp(params){
        //     this.loading = true;
        //     this.$api.post("merchant/updateDeduction", {id:params}, res => {
        //         if (res.code == 0) {
        //             let data = res.data;
        //             this.page.total = data.count; //总数
        //             this.withdrawalTable = data.list;
        //         } else {
        //             this.$message.error(res.msg);
        //         }
        //         //渲染结束后取消加载
        //         this.loading = false;
        //     })
        // },
        // //分页
        getCurrent(page) {
            // 获取当前页修改的值
            this.page.currentPage = page;
            this.litigationForm.page = this.page.currentPage;
            this.litigationForm.limit = this.page.pageSize;
            this.getData(this.litigationForm);
        },
        getPageSize(limit) {
            this.page.currentPage = 1; //重置分页
            // 获取条数发生改变的值
            this.page.pageSize = limit;
            this.withdrawalForm.page = this.page.currentPage;
            this.withdrawalForm.limit = limit;
            this.getData(this.withdrawalForm);
        },
        getuserData(params) { //获取列表
            this.loading = true;
            this.$api.post("merchant/getList", params, res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.wTable = data.list;
                } else {
                    this.$message.error(res.msg);
                }
                //渲染结束后取消加载
                this.loading = false;
            })
        },
    },
};
</script>

<style lang="scss" scope>
.FM_withdrawalList {
  .batchTitle {
    font-size: 12px;
    margin: 20px 0;
    :nth-child(1) {
      font-weight: 700;
      color: #1e1e1e;
    }
  }
  .el-dialog__body {
    padding: 0px 20px 30px 20px;
  }
  .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /*height:600px;*/
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);
  }
  .el-dialog .el-dialog__body {
    flex: 1;
    overflow: auto;
  }
}
</style>
